import React, { Fragment } from 'react';
import { Stack } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { MenuArrowRight as Arrow } from '@fortress-technology-solutions/fortress-component-library/Icons';
import sortBy from 'lodash/sortBy';
import type { Props } from './types';
import ProviderScreening from '../ProviderScreening';
import { hasMethodWithStatus } from '../hooks';
import { SCREENING_METHOD_STATUS } from '../ProviderScreening/constants';

function ScreeningProviderFlow({
  intl,
  providers,
  screeningStatus,
  phasedCriminalNotice,
}: Props) {
  const orderedProviders = sortBy(providers, 'order');

  const hasPendingScreeningMethods = hasMethodWithStatus(
    orderedProviders,
    SCREENING_METHOD_STATUS.PENDING,
  );

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{
        maxWidth: '100%',
        overflowX: 'auto',
        scrollbarWidth: 'thin',
        paddingBottom: 1,
      }}
    >
      {orderedProviders.map((provider, index) => (
        <Fragment key={provider.key ?? provider.order}>
          {index !== 0 && <Arrow sx={{ color: 'divider' }} fontSize="small" />}
          <ProviderScreening
            intl={intl}
            screeningMethods={provider.methods}
            screeningStatus={screeningStatus}
            hasPendingScreeningMethods={hasPendingScreeningMethods}
            highlighted={Boolean(
              provider.phasedCriminal && phasedCriminalNotice,
            )}
          >
            {provider.phasedCriminal ? phasedCriminalNotice : null}
          </ProviderScreening>
        </Fragment>
      ))}
    </Stack>
  );
}

export default ScreeningProviderFlow;
